import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Col, Row, Button, Badge } from "reactstrap";
import axios from "axios";
import moment from "moment";
import Header from "../../layout/Header/Header";

function BotonesAlmacen() {
  const { user } = useContext(AuthContext);
  const [pendientesSurtir, setPendientesSurtir] = useState(0);
  const [proximosRecibir, setProximosRecibir] = useState(0);

  // Badge "Surtir": mismo criterio que MenuVentas (U23)
  useEffect(() => {
    const URL = process.env.REACT_APP_URL_PEDIDOS;
    if (!URL) return;
    axios
      .get(`${URL}PendienteSurtir`, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then((res) => {
        const surtibles = (res.data || []).filter(
          (p) =>
            p.is_active === "Si" &&
            (p.status || "Abierto") === "Abierto" &&
            p.autorizadoSurtido === "Si" &&
            p.surtido !== "Si"
        );
        setPendientesSurtir(surtibles.length);
      })
      .catch(() => setPendientesSurtir(0));
  }, []);

  // Badge "Próximos a Recibir": mismo criterio que el filtro ?filtro=proximo
  // de ListadoEmbarques (no cancelados, no recibidos, ETA ≤ hoy+7).
  useEffect(() => {
    const URL = process.env.REACT_APP_URL_EMBARQUES;
    if (!URL) return;
    axios
      .get(URL, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then((res) => {
        const limite = moment().add(7, "days").format("YYYY-MM-DD");
        const proximos = (res.data || []).filter(
          (e) =>
            (e.is_active || "Si") !== "No" &&
            e.recibido !== "Si" &&
            e.fechaEstimada &&
            e.fechaEstimada <= limite
        );
        setProximosRecibir(proximos.length);
      })
      .catch(() => setProximosRecibir(0));
  }, []);

  const Btn = ({ permitido, href, icon, label, badge }) => (
    <Col md={4} align="center">
      {permitido ? (
        <Button href={href} className="botonesMenu" color="success" style={{ position: "relative" }}>
          {badge != null && badge > 0 && (
            <Badge color="danger" style={{ position: "absolute", top: 8, right: 8, fontSize: 14 }}>
              {badge}
            </Badge>
          )}
          <i className={`fas ${icon} fa-7x`}></i>
          <br />
          <br />
          {label}
        </Button>
      ) : (
        <Button disabled className="botonesMenu" color="success">
          <i className={`fas ${icon} fa-7x`}></i>
          <br />
          <br />
          {label}
        </Button>
      )}
    </Col>
  );

  return (
    <>
      <Header />
      <div className="container">
        <br />
        <br />
        <Row>
          <Btn permitido={user.menu_compras} href="/ListadoCompras" icon="fa-truck-loading" label="Entradas" />
          <Btn permitido={user.surtidos_create} href="/ListadoPendienteSurtir" icon="fa-truck-moving" label="Surtir" badge={pendientesSurtir} />
          <Btn permitido={user.menu_devoluciones} href="/ListadoDevoluciones" icon="fa-undo-alt" label="Devoluciones" />
        </Row>
        <br />
        <Row>
          <Btn permitido={user.menu_traspasos_salida} href="/ListadoTraspasosSalida" icon="fa-sign-out-alt" label="Traspasos Salida" />
          <Btn permitido={user.menu_traspasos_entrada} href="/ListadoTraspasosEntrada" icon="fa-sign-in-alt" label="Traspasos Entrada" />
          <Btn permitido={user.menu_inventarios} href="/ListadoInventarios" icon="fa-warehouse" label="Inventario" />
        </Row>
        <br />
        <Row>
          <Btn permitido={user.menu_compras || user.contenedoresAlmacen} href="/ListadoEmbarques?filtro=proximo" icon="fa-ship" label="Próximos a Recibir" badge={proximosRecibir} />
          <Btn permitido={user.ventasAlmacen || user.menu_surtidos} href="/ListadoVentasAlmacen" icon="fa-boxes" label={<>Ventas<br />Surtidas</>} />
        </Row>
      </div>
    </>
  );
}

export default BotonesAlmacen;
